// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AcceptHandoffData, AcceptHandoffErrors, AcceptHandoffResponses, AddAttachmentData, AddAttachmentErrors, AddAttachmentResponses, AddCommentData, AddCommentErrors, AddCommentResponses, AssignToBucketData, AssignToBucketErrors, AssignToBucketResponses, AutoAssignData, AutoAssignErrors, AutoAssignResponses, ConnectBudgetData, ConnectBudgetErrors, ConnectBudgetResponses, ConvertBucketData, ConvertBucketErrors, ConvertBucketResponses, ConvertEntryData, ConvertEntryErrors, ConvertEntryResponses, CreateApiKeyData, CreateApiKeyErrors, CreateApiKeyResponses, CreateBudgetData, CreateBudgetErrors, CreateBudgetResponses, CreateEntryData, CreateEntryErrors, CreateEntryResponses, DeleteApiKeyData, DeleteApiKeyErrors, DeleteApiKeyResponses, DeleteAttachmentData, DeleteAttachmentErrors, DeleteAttachmentResponses, DeleteCommentData, DeleteCommentErrors, DeleteCommentResponses, DeleteEntryData, DeleteEntryErrors, DeleteEntryResponses, FinishGithubLoginData, FinishGithubLoginErrors, FinishGithubLoginResponses, GetAttachmentData, GetAttachmentErrors, GetAttachmentResponses, GetAuthConfigData, GetAuthConfigResponses, GetBalancesData, GetBalancesErrors, GetBalancesResponses, GetBudgetData, GetBudgetErrors, GetBudgetResponses, GetEntryData, GetEntryErrors, GetEntryHistoryData, GetEntryHistoryErrors, GetEntryHistoryResponses, GetEntryNoteData, GetEntryNoteErrors, GetEntryNoteResponses, GetEntryResponses, GetHistoryData, GetHistoryDetailData, GetHistoryDetailErrors, GetHistoryDetailResponses, GetHistoryErrors, GetHistoryResponses, GetMeData, GetMeErrors, GetMeResponses, GetMonthData, GetMonthErrors, GetMonthResponses, InviteCollaboratorData, InviteCollaboratorErrors, InviteCollaboratorResponses, JoinBudgetData, JoinBudgetErrors, JoinBudgetResponses, ListApiKeysData, ListApiKeysErrors, ListApiKeysResponses, ListAttachmentsData, ListAttachmentsErrors, ListAttachmentsResponses, ListBucketsData, ListBucketsErrors, ListBucketsResponses, ListBudgetsData, ListBudgetsErrors, ListBudgetsResponses, ListCollaboratorsData, ListCollaboratorsErrors, ListCollaboratorsResponses, ListCommentsData, ListCommentsErrors, ListCommentsResponses, ListDueData, ListDueErrors, ListDueResponses, ListEntriesData, ListEntriesErrors, ListEntriesResponses, ListGithubReposData, ListGithubReposErrors, ListGithubReposResponses, ListMembersData, ListMembersErrors, ListMembersResponses, ListScheduledData, ListScheduledErrors, ListScheduledResponses, LogoutData, LogoutResponses, LookupRateData, LookupRateErrors, LookupRateResponses, MoveMoneyData, MoveMoneyErrors, MoveMoneyResponses, NearbyPlacesData, NearbyPlacesErrors, NearbyPlacesResponses, PollDeviceLoginData, PollDeviceLoginErrors, PollDeviceLoginResponses, PostScheduledData, PostScheduledErrors, PostScheduledResponses, PutBucketData, PutBucketErrors, PutBucketResponses, PutEntryNoteData, PutEntryNoteErrors, PutEntryNoteResponses, PutMembersData, PutMembersErrors, PutMembersResponses, PutScheduledData, PutScheduledErrors, PutScheduledResponses, RedoChangeData, RedoChangeErrors, RedoChangeResponses, ReorderBucketsData, ReorderBucketsErrors, ReorderBucketsResponses, SearchGithubUsersData, SearchGithubUsersErrors, SearchGithubUsersResponses, SearchPlacesData, SearchPlacesErrors, SearchPlacesResponses, SettleUpData, SettleUpErrors, SettleUpResponses, StartDeviceLoginData, StartDeviceLoginResponses, StartGithubLoginData, StartGithubLoginErrors, StartGithubLoginResponses, SuggestEntryData, SuggestEntryErrors, SuggestEntryResponses, SuggestPayeesData, SuggestPayeesErrors, SuggestPayeesResponses, UndoChangeData, UndoChangeErrors, UndoChangeResponses, UpdateEntryData, UpdateEntryErrors, UpdateEntryResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Get Auth Config
 *
 * Where this deployment's sign-in starts.
 *
 * Computed server-side because only the server knows whether it is production or a preview;
 * the browser guessing its own prod origin from the hostname would be one more thing to
 * keep correct.
 */
export const getAuthConfig = <ThrowOnError extends boolean = false>(options?: Options<GetAuthConfigData, ThrowOnError>): RequestResult<GetAuthConfigResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAuthConfigResponses, unknown, ThrowOnError>({ url: '/api/v1/auth/config', ...options });

/**
 * Begin browser sign-in
 */
export const startGithubLogin = <ThrowOnError extends boolean = false>(options?: Options<StartGithubLoginData, ThrowOnError>): RequestResult<StartGithubLoginResponses, StartGithubLoginErrors, ThrowOnError> => (options?.client ?? client).get<StartGithubLoginResponses, StartGithubLoginErrors, ThrowOnError>({ url: '/api/v1/auth/github/start', ...options });

/**
 * OAuth callback
 */
export const finishGithubLogin = <ThrowOnError extends boolean = false>(options: Options<FinishGithubLoginData, ThrowOnError>): RequestResult<FinishGithubLoginResponses, FinishGithubLoginErrors, ThrowOnError> => (options.client ?? client).get<FinishGithubLoginResponses, FinishGithubLoginErrors, ThrowOnError>({ url: '/api/v1/auth/github/callback', ...options });

/**
 * Accept a preview sign-in ticket
 *
 * Complete a sign-in that production started on this preview's behalf.
 *
 * The ticket is checked against *this* deployment's own hostname, so a ticket minted for
 * `pr-42` is useless at `pr-43` even though both trust the same signing key.
 */
export const acceptHandoff = <ThrowOnError extends boolean = false>(options: Options<AcceptHandoffData, ThrowOnError>): RequestResult<AcceptHandoffResponses, AcceptHandoffErrors, ThrowOnError> => (options.client ?? client).get<AcceptHandoffResponses, AcceptHandoffErrors, ThrowOnError>({ url: '/api/v1/auth/handoff', ...options });

/**
 * Sign out
 */
export const logout = <ThrowOnError extends boolean = false>(options?: Options<LogoutData, ThrowOnError>): RequestResult<LogoutResponses, unknown, ThrowOnError> => (options?.client ?? client).post<LogoutResponses, unknown, ThrowOnError>({ url: '/api/v1/auth/logout', ...options });

/**
 * Begin CLI sign-in
 */
export const startDeviceLogin = <ThrowOnError extends boolean = false>(options?: Options<StartDeviceLoginData, ThrowOnError>): RequestResult<StartDeviceLoginResponses, unknown, ThrowOnError> => (options?.client ?? client).post<StartDeviceLoginResponses, unknown, ThrowOnError>({ url: '/api/v1/auth/device/start', ...options });

/**
 * Exchange an approved device code for an API key
 *
 * Returns `pending` until the user approves in their browser.
 *
 * On approval this mints a *money* API key rather than handing the CLI the GitHub token,
 * so revoking CLI access never means revoking GitHub access.
 */
export const pollDeviceLogin = <ThrowOnError extends boolean = false>(options: Options<PollDeviceLoginData, ThrowOnError>): RequestResult<PollDeviceLoginResponses, PollDeviceLoginErrors, ThrowOnError> => (options.client ?? client).post<PollDeviceLoginResponses, PollDeviceLoginErrors, ThrowOnError>({
    url: '/api/v1/auth/device/poll',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Budgets you can see
 *
 * Every linked budget whose repo GitHub says the caller can read.
 *
 * Budgets they cannot read are omitted, not reported as forbidden.
 */
export const listBudgets = <ThrowOnError extends boolean = false>(options?: Options<ListBudgetsData, ThrowOnError>): RequestResult<ListBudgetsResponses, ListBudgetsErrors, ThrowOnError> => (options?.client ?? client).get<ListBudgetsResponses, ListBudgetsErrors, ThrowOnError>({ url: '/api/v1/budgets', ...options });

/**
 * Connect a GitHub repo as a budget
 */
export const connectBudget = <ThrowOnError extends boolean = false>(options: Options<ConnectBudgetData, ThrowOnError>): RequestResult<ConnectBudgetResponses, ConnectBudgetErrors, ThrowOnError> => (options.client ?? client).post<ConnectBudgetResponses, ConnectBudgetErrors, ThrowOnError>({
    url: '/api/v1/budgets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start a new budget in a new or empty repo
 *
 * Create the repo, write the first `budget.yaml`, and link it — in one call.
 *
 * Connecting a repo assumed one already held a budget, which left someone with no budget
 * at all nowhere to start: the only route in was hand-writing YAML on github.com. This is
 * that missing step, and it is deliberately one call because every intermediate state
 * (repo but no budget, budget but no buckets) is one the person would have to be told
 * about for no reason.
 */
export const createBudget = <ThrowOnError extends boolean = false>(options: Options<CreateBudgetData, ThrowOnError>): RequestResult<CreateBudgetResponses, CreateBudgetErrors, ThrowOnError> => (options.client ?? client).post<CreateBudgetResponses, CreateBudgetErrors, ThrowOnError>({
    url: '/api/v1/budgets/create',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * One budget
 */
export const getBudget = <ThrowOnError extends boolean = false>(options: Options<GetBudgetData, ThrowOnError>): RequestResult<GetBudgetResponses, GetBudgetErrors, ThrowOnError> => (options.client ?? client).get<GetBudgetResponses, GetBudgetErrors, ThrowOnError>({ url: '/api/v1/budgets/{budget}', ...options });

/**
 * Who is in this budget
 */
export const listMembers = <ThrowOnError extends boolean = false>(options: Options<ListMembersData, ThrowOnError>): RequestResult<ListMembersResponses, ListMembersErrors, ThrowOnError> => (options.client ?? client).get<ListMembersResponses, ListMembersErrors, ThrowOnError>({ url: '/api/v1/budgets/{budget}/members', ...options });

/**
 * Replace the member list
 *
 * Replaces the list wholesale, so removals are expressible and not just additions.
 *
 * Membership decides who can be assigned a share, not who can reach the budget — that is
 * GitHub repo access. Someone listed here without repo access simply never signs in.
 */
export const putMembers = <ThrowOnError extends boolean = false>(options: Options<PutMembersData, ThrowOnError>): RequestResult<PutMembersResponses, PutMembersErrors, ThrowOnError> => (options.client ?? client).put<PutMembersResponses, PutMembersErrors, ThrowOnError>({
    url: '/api/v1/budgets/{budget}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add yourself to a budget you can push to
 *
 * Join a budget whose repo you already have push access to.
 *
 * Without this, being handed a budget repo by someone who forgot to add you to
 * `budget.yaml` made every screen fail with a 403 telling you to go and edit YAML — while
 * the app's own member editor sat behind the same 403. Push access is the authority the
 * rest of the app already trusts to decide who may change this data; refusing to let a
 * person with that access name themselves was the app contradicting itself.
 *
 * It only ever adds you. Editing anyone else stays with `putMembers`, where removing
 * someone is checked against the entries that reference them.
 */
export const joinBudget = <ThrowOnError extends boolean = false>(options: Options<JoinBudgetData, ThrowOnError>): RequestResult<JoinBudgetResponses, JoinBudgetErrors, ThrowOnError> => (options.client ?? client).post<JoinBudgetResponses, JoinBudgetErrors, ThrowOnError>({
    url: '/api/v1/budgets/{budget}/members/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Envelope view for a month
 *
 * Buckets are shared, so this returns every funder's standing in each of them.
 *
 * `person` still decides whose ready-to-assign is reported, because income arrives to a
 * person and so does the money that has not been given a job yet.
 */
export const getMonth = <ThrowOnError extends boolean = false>(options: Options<GetMonthData, ThrowOnError>): RequestResult<GetMonthResponses, GetMonthErrors, ThrowOnError> => (options.client ?? client).get<GetMonthResponses, GetMonthErrors, ThrowOnError>({ url: '/api/v1/budgets/{budget}/months/{month}', ...options });

/**
 * Assign money to a bucket
 */
export const assignToBucket = <ThrowOnError extends boolean = false>(options: Options<AssignToBucketData, ThrowOnError>): RequestResult<AssignToBucketResponses, AssignToBucketErrors, ThrowOnError> => (options.client ?? client).put<AssignToBucketResponses, AssignToBucketErrors, ThrowOnError>({
    url: '/api/v1/budgets/{budget}/months/{month}/assign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Fund several buckets at once
 *
 * Assign to many buckets in one action, which is the payday case.
 *
 * Funding envelopes one at a time is the single most repeated chore in envelope budgeting.
 * Three strategies cover it: top every bucket up to its target, or repeat what was assigned
 * or spent last month.
 *
 * A bucket's target belongs to the household, so filling it fills it **in the bucket's split
 * ratio** — four people at 25% each put in a quarter of the shortfall. Funding is otherwise
 * nobody's business but their own, which is why the other two strategies stay personal: what
 * *you* assigned or spent last month says nothing about what anyone else did.
 *
 * This deliberately does not stop when the money runs out. Any funder's ready-to-assign is
 * allowed to go negative, and the month view says so — refusing would leave the plan
 * half-applied and harder to reason about than an overcommitment you can see.
 */
export const autoAssign = <ThrowOnError extends boolean = false>(options: Options<AutoAssignData, ThrowOnError>): RequestResult<AutoAssignResponses, AutoAssignErrors, ThrowOnError> => (options.client ?? client).post<AutoAssignResponses, AutoAssignErrors, ThrowOnError>({
    url: '/api/v1/budgets/{budget}/months/{month}/auto-assign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Move money from one bucket to another
 *
 * Take from one envelope and give to another, in one action.
 *
 * Covering an overspend by editing two assignment figures means doing the arithmetic
 * yourself and leaving the budget briefly wrong between the two saves. This does both sides
 * together and refuses to move more than the source actually holds.
 */
export const moveMoney = <ThrowOnError extends boolean = false>(options: Options<MoveMoneyData, ThrowOnError>): RequestResult<MoveMoneyResponses, MoveMoneyErrors, ThrowOnError> => (options.client ?? client).post<MoveMoneyResponses, MoveMoneyErrors, ThrowOnError>({
    url: '/api/v1/budgets/{budget}/months/{month}/move',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Move buckets into a new order, in one commit
 *
 * One drag, one commit.
 *
 * A drag can shift every bucket it passes, and they all live in one file — so doing it a
 * bucket at a time meant N requests, each a full fetch, commit and push, all rewriting the
 * same file. Beyond being slow, it made the reorder non-atomic: a failure partway left a
 * half-applied order, and the intermediate states were briefly visible to anyone else.
 *
 * It cannot create, delete, rename or retarget a bucket. Position is the only thing a drag
 * means, and a wholesale replace would let a client holding a stale list undo somebody
 * else's rename in passing.
 */
export const reorderBuckets = <ThrowOnError extends boolean = false>(options: Options<ReorderBucketsData, ThrowOnError>): RequestResult<ReorderBucketsResponses, ReorderBucketsErrors, ThrowOnError> => (options.client ?? client).put<ReorderBucketsResponses, ReorderBucketsErrors, ThrowOnError>({
    url: '/api/v1/budgets/{budget}/buckets/order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or update one of your buckets
 */
export const putBucket = <ThrowOnError extends boolean = false>(options: Options<PutBucketData, ThrowOnError>): RequestResult<PutBucketResponses, PutBucketErrors, ThrowOnError> => (options.client ?? client).put<PutBucketResponses, PutBucketErrors, ThrowOnError>({
    url: '/api/v1/budgets/{budget}/buckets/{bucket_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Every bucket in the budget
 *
 * Buckets are shared, so this no longer takes a person.
 *
 * Each one carries the split that decides who bears its spending; how much any individual
 * has put in lives in the month view, not here.
 */
export const listBuckets = <ThrowOnError extends boolean = false>(options: Options<ListBucketsData, ThrowOnError>): RequestResult<ListBucketsResponses, ListBucketsErrors, ThrowOnError> => (options.client ?? client).get<ListBucketsResponses, ListBucketsErrors, ThrowOnError>({ url: '/api/v1/budgets/{budget}/buckets', ...options });

/**
 * Who owes whom
 */
export const getBalances = <ThrowOnError extends boolean = false>(options: Options<GetBalancesData, ThrowOnError>): RequestResult<GetBalancesResponses, GetBalancesErrors, ThrowOnError> => (options.client ?? client).get<GetBalancesResponses, GetBalancesErrors, ThrowOnError>({ url: '/api/v1/budgets/{budget}/balances', ...options });

/**
 * Record a payment between two people
 *
 * A settlement moves both net positions and touches no envelope.
 *
 * `payer` defaults to the calling user but may name the other party. The person who is
 * *owed* is usually the one holding the phone when the money arrives, and if their partner
 * does not use the app nobody could otherwise record it. The caller must be one of the two
 * parties, so this records payments you were involved in, not other people's.
 */
export const settleUp = <ThrowOnError extends boolean = false>(options: Options<SettleUpData, ThrowOnError>): RequestResult<SettleUpResponses, SettleUpErrors, ThrowOnError> => (options.client ?? client).post<SettleUpResponses, SettleUpErrors, ThrowOnError>({
    url: '/api/v1/budgets/{budget}/settle',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * What one unit of a currency is worth in the budget's, on a day
 *
 * Read-only: answers from the table, else asks the provider without committing. The
 * rate is committed only by the conversion that uses it, so the form can show what a
 * conversion would do without leaving a row nothing depends on.
 */
export const lookupRate = <ThrowOnError extends boolean = false>(options: Options<LookupRateData, ThrowOnError>): RequestResult<LookupRateResponses, LookupRateErrors, ThrowOnError> => (options.client ?? client).get<LookupRateResponses, LookupRateErrors, ThrowOnError>({ url: '/api/v1/budgets/{budget}/rates', ...options });

/**
 * Convert every unconverted entry in one currency with a share in a bucket
 *
 * One rate, one commit. An entry whose shares span two buckets converts whole, because an
 * entry has one `fx`; those are listed so the person knows the other bucket moved too.
 * See specs/currency.md, CUR-8.
 */
export const convertBucket = <ThrowOnError extends boolean = false>(options: Options<ConvertBucketData, ThrowOnError>): RequestResult<ConvertBucketResponses, ConvertBucketErrors, ThrowOnError> => (options.client ?? client).post<ConvertBucketResponses, ConvertBucketErrors, ThrowOnError>({
    url: '/api/v1/budgets/{budget}/buckets/{bucket_id}/convert',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List entries
 */
export const listEntries = <ThrowOnError extends boolean = false>(options: Options<ListEntriesData, ThrowOnError>): RequestResult<ListEntriesResponses, ListEntriesErrors, ThrowOnError> => (options.client ?? client).get<ListEntriesResponses, ListEntriesErrors, ThrowOnError>({ url: '/api/v1/budgets/{budget}/entries', ...options });

/**
 * Record an entry
 */
export const createEntry = <ThrowOnError extends boolean = false>(options: Options<CreateEntryData, ThrowOnError>): RequestResult<CreateEntryResponses, CreateEntryErrors, ThrowOnError> => (options.client ?? client).post<CreateEntryResponses, CreateEntryErrors, ThrowOnError>({
    url: '/api/v1/budgets/{budget}/entries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Payees you have used before
 *
 * Payees from this budget's own history, with the amount and bucket usually used.
 *
 * Typing a shop's name in full every time is the slowest part of logging an expense, and
 * the answer is already in the ledger. Ranked by how recently *and* how often a payee was
 * used: a shop visited weekly should beat one visited once a year, but a one-off from
 * yesterday should still be reachable.
 */
export const suggestPayees = <ThrowOnError extends boolean = false>(options: Options<SuggestPayeesData, ThrowOnError>): RequestResult<SuggestPayeesResponses, SuggestPayeesErrors, ThrowOnError> => (options.client ?? client).get<SuggestPayeesResponses, SuggestPayeesErrors, ThrowOnError>({ url: '/api/v1/budgets/{budget}/entries/payees', ...options });

/**
 * Delete an entry
 */
export const deleteEntry = <ThrowOnError extends boolean = false>(options: Options<DeleteEntryData, ThrowOnError>): RequestResult<DeleteEntryResponses, DeleteEntryErrors, ThrowOnError> => (options.client ?? client).delete<DeleteEntryResponses, DeleteEntryErrors, ThrowOnError>({ url: '/api/v1/budgets/{budget}/entries/{entry_id}', ...options });

/**
 * Get one entry
 */
export const getEntry = <ThrowOnError extends boolean = false>(options: Options<GetEntryData, ThrowOnError>): RequestResult<GetEntryResponses, GetEntryErrors, ThrowOnError> => (options.client ?? client).get<GetEntryResponses, GetEntryErrors, ThrowOnError>({ url: '/api/v1/budgets/{budget}/entries/{entry_id}', ...options });

/**
 * Edit an entry
 */
export const updateEntry = <ThrowOnError extends boolean = false>(options: Options<UpdateEntryData, ThrowOnError>): RequestResult<UpdateEntryResponses, UpdateEntryErrors, ThrowOnError> => (options.client ?? client).patch<UpdateEntryResponses, UpdateEntryErrors, ThrowOnError>({
    url: '/api/v1/budgets/{budget}/entries/{entry_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Commits that touched this entry
 */
export const getEntryHistory = <ThrowOnError extends boolean = false>(options: Options<GetEntryHistoryData, ThrowOnError>): RequestResult<GetEntryHistoryResponses, GetEntryHistoryErrors, ThrowOnError> => (options.client ?? client).get<GetEntryHistoryResponses, GetEntryHistoryErrors, ThrowOnError>({ url: '/api/v1/budgets/{budget}/entries/{entry_id}/history', ...options });

/**
 * Long-form note for an entry
 */
export const getEntryNote = <ThrowOnError extends boolean = false>(options: Options<GetEntryNoteData, ThrowOnError>): RequestResult<GetEntryNoteResponses, GetEntryNoteErrors, ThrowOnError> => (options.client ?? client).get<GetEntryNoteResponses, GetEntryNoteErrors, ThrowOnError>({ url: '/api/v1/budgets/{budget}/entries/{entry_id}/note', ...options });

/**
 * Write the long-form note for an entry
 *
 * Markdown in `notes/<entry-id>.md`, so a paragraph of context diffs line by line.
 */
export const putEntryNote = <ThrowOnError extends boolean = false>(options: Options<PutEntryNoteData, ThrowOnError>): RequestResult<PutEntryNoteResponses, PutEntryNoteErrors, ThrowOnError> => (options.client ?? client).put<PutEntryNoteResponses, PutEntryNoteErrors, ThrowOnError>({
    url: '/api/v1/budgets/{budget}/entries/{entry_id}/note',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Convert an unconverted entry into the budget currency
 *
 * Adds `fx` at the rate for the day of conversion — that is what "convert it now" means
 * — or another day's, or one typed. See specs/currency.md, CUR-7.
 */
export const convertEntry = <ThrowOnError extends boolean = false>(options: Options<ConvertEntryData, ThrowOnError>): RequestResult<ConvertEntryResponses, ConvertEntryErrors, ThrowOnError> => (options.client ?? client).post<ConvertEntryResponses, ConvertEntryErrors, ThrowOnError>({
    url: '/api/v1/budgets/{budget}/entries/{entry_id}/convert',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The conversation under an entry
 */
export const listComments = <ThrowOnError extends boolean = false>(options: Options<ListCommentsData, ThrowOnError>): RequestResult<ListCommentsResponses, ListCommentsErrors, ThrowOnError> => (options.client ?? client).get<ListCommentsResponses, ListCommentsErrors, ThrowOnError>({ url: '/api/v1/budgets/{budget}/entries/{entry_id}/comments', ...options });

/**
 * Say something under an entry
 *
 * Appends and returns the whole thread, so a client can render the reply in place
 * without a second round trip — the thread is short by nature.
 */
export const addComment = <ThrowOnError extends boolean = false>(options: Options<AddCommentData, ThrowOnError>): RequestResult<AddCommentResponses, AddCommentErrors, ThrowOnError> => (options.client ?? client).post<AddCommentResponses, AddCommentErrors, ThrowOnError>({
    url: '/api/v1/budgets/{budget}/entries/{entry_id}/comments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Take back something you said
 *
 * Only the author. A comment is attributed speech, and removing someone else's words
 * from a shared record is not an edit anybody should be able to make silently.
 */
export const deleteComment = <ThrowOnError extends boolean = false>(options: Options<DeleteCommentData, ThrowOnError>): RequestResult<DeleteCommentResponses, DeleteCommentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCommentResponses, DeleteCommentErrors, ThrowOnError>({ url: '/api/v1/budgets/{budget}/entries/{entry_id}/comments/{comment_id}', ...options });

/**
 * Files kept beside an entry
 */
export const listAttachments = <ThrowOnError extends boolean = false>(options: Options<ListAttachmentsData, ThrowOnError>): RequestResult<ListAttachmentsResponses, ListAttachmentsErrors, ThrowOnError> => (options.client ?? client).get<ListAttachmentsResponses, ListAttachmentsErrors, ThrowOnError>({ url: '/api/v1/budgets/{budget}/entries/{entry_id}/attachments', ...options });

/**
 * Attach a receipt photo or PDF
 *
 * The body is the file itself.
 *
 * Raw bytes rather than multipart: there is exactly one file per request, so a multipart
 * envelope would add a parser dependency and a field name for nothing. The type comes from
 * the Content-Type header when it names one we accept, else from `media_type` — a
 * generated client sends the schema's octet-stream header and cannot say more.
 */
export const addAttachment = <ThrowOnError extends boolean = false>(options: Options<AddAttachmentData, ThrowOnError>): RequestResult<AddAttachmentResponses, AddAttachmentErrors, ThrowOnError> => (options.client ?? client).post<AddAttachmentResponses, AddAttachmentErrors, ThrowOnError>({
    bodySerializer: null,
    url: '/api/v1/budgets/{budget}/entries/{entry_id}/attachments',
    ...options,
    headers: {
        'content-type': 'application/octet-stream',
        ...options.headers
    }
});

/**
 * Remove a file from an entry
 */
export const deleteAttachment = <ThrowOnError extends boolean = false>(options: Options<DeleteAttachmentData, ThrowOnError>): RequestResult<DeleteAttachmentResponses, DeleteAttachmentErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAttachmentResponses, DeleteAttachmentErrors, ThrowOnError>({ url: '/api/v1/budgets/{budget}/entries/{entry_id}/attachments/{name}', ...options });

/**
 * The file itself
 */
export const getAttachment = <ThrowOnError extends boolean = false>(options: Options<GetAttachmentData, ThrowOnError>): RequestResult<GetAttachmentResponses, GetAttachmentErrors, ThrowOnError> => (options.client ?? client).get<GetAttachmentResponses, GetAttachmentErrors, ThrowOnError>({ url: '/api/v1/budgets/{budget}/entries/{entry_id}/attachments/{name}', ...options });

/**
 * Who am I
 */
export const getMe = <ThrowOnError extends boolean = false>(options?: Options<GetMeData, ThrowOnError>): RequestResult<GetMeResponses, GetMeErrors, ThrowOnError> => (options?.client ?? client).get<GetMeResponses, GetMeErrors, ThrowOnError>({ url: '/api/v1/me', ...options });

/**
 * Your API keys
 */
export const listApiKeys = <ThrowOnError extends boolean = false>(options?: Options<ListApiKeysData, ThrowOnError>): RequestResult<ListApiKeysResponses, ListApiKeysErrors, ThrowOnError> => (options?.client ?? client).get<ListApiKeysResponses, ListApiKeysErrors, ThrowOnError>({ url: '/api/v1/me/keys', ...options });

/**
 * Create an API key
 *
 * The token is returned once here and never again; only its hash is stored.
 */
export const createApiKey = <ThrowOnError extends boolean = false>(options: Options<CreateApiKeyData, ThrowOnError>): RequestResult<CreateApiKeyResponses, CreateApiKeyErrors, ThrowOnError> => (options.client ?? client).post<CreateApiKeyResponses, CreateApiKeyErrors, ThrowOnError>({
    url: '/api/v1/me/keys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke an API key
 */
export const deleteApiKey = <ThrowOnError extends boolean = false>(options: Options<DeleteApiKeyData, ThrowOnError>): RequestResult<DeleteApiKeyResponses, DeleteApiKeyErrors, ThrowOnError> => (options.client ?? client).delete<DeleteApiKeyResponses, DeleteApiKeyErrors, ThrowOnError>({ url: '/api/v1/me/keys/{key_id}', ...options });

/**
 * Repos you could connect as a budget
 *
 * Lists the caller's repos, flagging which already look like a budget.
 *
 * "Looks like a budget" means it has a `budget.yaml`. That is checked for the most recently
 * pushed repos only — one API call each — and everything else is still listed, just without
 * the flag. Guessing wrong is cheap: connecting a repo without one fails with a clear error.
 */
export const listGithubRepos = <ThrowOnError extends boolean = false>(options?: Options<ListGithubReposData, ThrowOnError>): RequestResult<ListGithubReposResponses, ListGithubReposErrors, ThrowOnError> => (options?.client ?? client).get<ListGithubReposResponses, ListGithubReposErrors, ThrowOnError>({ url: '/api/v1/github/repos', ...options });

/**
 * Find a GitHub user to invite
 */
export const searchGithubUsers = <ThrowOnError extends boolean = false>(options: Options<SearchGithubUsersData, ThrowOnError>): RequestResult<SearchGithubUsersResponses, SearchGithubUsersErrors, ThrowOnError> => (options.client ?? client).get<SearchGithubUsersResponses, SearchGithubUsersErrors, ThrowOnError>({ url: '/api/v1/github/users', ...options });

/**
 * Who has access to the data repo
 *
 * Repo access is the real permission model, so this shows it directly.
 *
 * Pending invitations are included: without them someone just invited does not appear at
 * all, and it looks as though the invitation failed.
 */
export const listCollaborators = <ThrowOnError extends boolean = false>(options: Options<ListCollaboratorsData, ThrowOnError>): RequestResult<ListCollaboratorsResponses, ListCollaboratorsErrors, ThrowOnError> => (options.client ?? client).get<ListCollaboratorsResponses, ListCollaboratorsErrors, ThrowOnError>({ url: '/api/v1/budgets/{budget}/collaborators', ...options });

/**
 * Invite someone to the budget's data repo
 *
 * Sends a real GitHub invitation, and adds them to the budget's member list.
 *
 * Both halves are needed and they are not the same thing: the invitation is what lets them
 * sign in at all, and membership is what lets them hold a share of an entry. Doing only the
 * first was the old behaviour, and it left people able to log in to a budget that could not
 * reference them.
 */
export const inviteCollaborator = <ThrowOnError extends boolean = false>(options: Options<InviteCollaboratorData, ThrowOnError>): RequestResult<InviteCollaboratorResponses, InviteCollaboratorErrors, ThrowOnError> => (options.client ?? client).post<InviteCollaboratorResponses, InviteCollaboratorErrors, ThrowOnError>({
    url: '/api/v1/budgets/{budget}/invite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Recurring entries
 */
export const listScheduled = <ThrowOnError extends boolean = false>(options: Options<ListScheduledData, ThrowOnError>): RequestResult<ListScheduledResponses, ListScheduledErrors, ThrowOnError> => (options.client ?? client).get<ListScheduledResponses, ListScheduledErrors, ThrowOnError>({ url: '/api/v1/budgets/{budget}/scheduled', ...options });

/**
 * Replace the recurring entries
 */
export const putScheduled = <ThrowOnError extends boolean = false>(options: Options<PutScheduledData, ThrowOnError>): RequestResult<PutScheduledResponses, PutScheduledErrors, ThrowOnError> => (options.client ?? client).put<PutScheduledResponses, PutScheduledErrors, ThrowOnError>({
    url: '/api/v1/budgets/{budget}/scheduled',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Recurring entries that are due
 *
 * What each recurrence owes the ledger, up to `through` (default: two weeks out).
 *
 * Dates already posted are excluded, so opening this twice never offers the same charge
 * twice. A paused recurrence is skipped entirely.
 */
export const listDue = <ThrowOnError extends boolean = false>(options: Options<ListDueData, ThrowOnError>): RequestResult<ListDueResponses, ListDueErrors, ThrowOnError> => (options.client ?? client).get<ListDueResponses, ListDueErrors, ThrowOnError>({ url: '/api/v1/budgets/{budget}/scheduled/due', ...options });

/**
 * Turn a due recurrence into a real entry
 *
 * Creates the entry and records that this date was posted, in one commit.
 *
 * One commit matters: if the entry landed and the marker did not, the same charge would be
 * offered again and posted twice.
 */
export const postScheduled = <ThrowOnError extends boolean = false>(options: Options<PostScheduledData, ThrowOnError>): RequestResult<PostScheduledResponses, PostScheduledErrors, ThrowOnError> => (options.client ?? client).post<PostScheduledResponses, PostScheduledErrors, ThrowOnError>({
    url: '/api/v1/budgets/{budget}/scheduled/{scheduled_id}/post',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Everything that has changed, newest first
 *
 * One feed for every change, whichever file it touched.
 *
 * Assignments show up next to entries because they are the same kind of event to the person
 * reading — money moved — even though one lives in a ledger file and the other in a map.
 */
export const getHistory = <ThrowOnError extends boolean = false>(options: Options<GetHistoryData, ThrowOnError>): RequestResult<GetHistoryResponses, GetHistoryErrors, ThrowOnError> => (options.client ?? client).get<GetHistoryResponses, GetHistoryErrors, ThrowOnError>({ url: '/api/v1/budgets/{budget}/history', ...options });

/**
 * What one change actually did
 *
 * The diff, so "what did this change" has an answer that is not a guess.
 *
 * A subject line names what someone meant to do. The patch is what actually happened, and
 * for a data model stored as YAML it reads well enough to be the answer rather than a
 * debugging aid — an assignment is one number changing on one line.
 *
 * Whether it can still be undone is answered here rather than left to the client, because
 * it needs the whole log: a change that something later reverted is no longer applied, and
 * offering to undo it again would revert the revert.
 */
export const getHistoryDetail = <ThrowOnError extends boolean = false>(options: Options<GetHistoryDetailData, ThrowOnError>): RequestResult<GetHistoryDetailResponses, GetHistoryDetailErrors, ThrowOnError> => (options.client ?? client).get<GetHistoryDetailResponses, GetHistoryDetailErrors, ThrowOnError>({ url: '/api/v1/budgets/{budget}/history/{sha}', ...options });

/**
 * Undo a change you made
 *
 * Revert a change, defaulting to your most recent un-reverted one.
 *
 * Scoped to your own changes: in a shared budget, silently reversing your partner's work
 * from your phone is the failure worth designing against. Naming a sha reverts anyone's,
 * which makes doing so deliberate.
 */
export const undoChange = <ThrowOnError extends boolean = false>(options: Options<UndoChangeData, ThrowOnError>): RequestResult<UndoChangeResponses, UndoChangeErrors, ThrowOnError> => (options.client ?? client).post<UndoChangeResponses, UndoChangeErrors, ThrowOnError>({ url: '/api/v1/budgets/{budget}/history/undo', ...options });

/**
 * Re-apply something you undid
 *
 * Re-apply the change your last undo reversed, by reverting the revert.
 *
 * Only available while the undo is still your most recent change. Anything done afterwards
 * clears it, the way a new edit clears an editor's redo stack — re-applying a change on top
 * of later work would produce a state nobody asked for.
 */
export const redoChange = <ThrowOnError extends boolean = false>(options: Options<RedoChangeData, ThrowOnError>): RequestResult<RedoChangeResponses, RedoChangeErrors, ThrowOnError> => (options.client ?? client).post<RedoChangeResponses, RedoChangeErrors, ThrowOnError>({ url: '/api/v1/budgets/{budget}/history/redo', ...options });

/**
 * Venues around a point
 *
 * Names the shop someone is standing in, so the first visit does not need typing.
 *
 * Proxied rather than called from the browser, so the API key stays on the server. Returns
 * an empty list rather than an error when the lookup fails — a places outage should not
 * stop anyone recording an expense.
 */
export const nearbyPlaces = <ThrowOnError extends boolean = false>(options: Options<NearbyPlacesData, ThrowOnError>): RequestResult<NearbyPlacesResponses, NearbyPlacesErrors, ThrowOnError> => (options.client ?? client).get<NearbyPlacesResponses, NearbyPlacesErrors, ThrowOnError>({ url: '/api/v1/places/nearby', ...options });

/**
 * Find a venue by name
 *
 * Naming a place you are not standing in.
 *
 * Nearby covers the common case — the shop you are in right now — but not recording
 * yesterday's lunch, or anywhere you have already left. Coordinates bias the ranking when
 * they are known and are simply omitted when they are not.
 */
export const searchPlaces = <ThrowOnError extends boolean = false>(options: Options<SearchPlacesData, ThrowOnError>): RequestResult<SearchPlacesResponses, SearchPlacesErrors, ThrowOnError> => (options.client ?? client).get<SearchPlacesResponses, SearchPlacesErrors, ThrowOnError>({ url: '/api/v1/places/search', ...options });

/**
 * A guessed entry, with its reasoning
 *
 * What this person probably about to record, drawn only from this budget's own history.
 *
 * Every field the caller already knows narrows the pool the rest is drawn from, so filling
 * in the payee improves the amount and the split rather than being ignored.
 */
export const suggestEntry = <ThrowOnError extends boolean = false>(options: Options<SuggestEntryData, ThrowOnError>): RequestResult<SuggestEntryResponses, SuggestEntryErrors, ThrowOnError> => (options.client ?? client).get<SuggestEntryResponses, SuggestEntryErrors, ThrowOnError>({ url: '/api/v1/budgets/{budget}/suggest', ...options });
